export default "__VITE_ASSET__B602L_sF__"